<template>
  <div class="page-separate" contenteditable="false"></div>
</template>

<script>
import 'babel-polyfill';
import http_method from '../mixins/http_method';
import announce_message from '../mixins/announce_message';
import 'element-plus';

export default {
  name: 'PageSeparate',
  components: {},
  data() {
    return {};
  },
  props: {},
  emits: [],
  methods: {},
  mixins: [http_method, announce_message],
  created() {},
  mounted() {},
  watch: {},
};
</script>
